<section class="anim-loading"
  *ngIf="currentUser?.adminManagerUser || currentUser?.superUser">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="page-title mb-0">
          <h2 i18n>Administrar Módulo</h2>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="d-flex justify-content-end">
          <button i18n type="button"
            class="btn btn-fade-primary mr-2"
            [ngClass]="{ 'active': viewMode === viewModes.user }"
            (click)="setViewMode(viewModes.user)">Usuários</button>
          <button i18n type="button"
            class="btn btn-fade-primary"
            [ngClass]="{ 'active': viewMode === viewModes.permission }"
            (click)="setViewMode(viewModes.permission)">Permissões</button>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <form [formGroup]="searchForm">
          <div class="form-group">
            <input type="text" class="form-control form-search"
              formControlName="search" i18n-placeholder
              placeholder="Buscar registro"
              autocomplete="off">
          </div>
        </form>
      </div>
    </div>
    <div class="loading-page" *ngIf="loading">
      <div class="loading-spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="!loading">
      <div class="col-md-12">
        <app-users
          [users]="users"
          *ngIf="viewMode === viewModes.user"></app-users>
        <app-permissions
          [permissions]="permissions"
          *ngIf="viewMode === viewModes.permission"></app-permissions>
      </div>
    </div>
    <div class="row mt-2" *ngIf="viewMode === viewModes.user && !loading">
      <div class="col-md-12">
        <app-pagination-simple
          (items)="setUsersDara($event)"
          [data]="usersData">
        </app-pagination-simple>
      </div>
      <!-- <div class="col-md-12">
        <app-pagination-url
          [service]="administrativeService"
          [params]="params"
          [pageSize]="params.pageSize"
          (items)="setUsers($event)">
        </app-pagination-url>
      </div> -->
    </div>
  </div>
</section>
